/**
 * Terminal (non-retryable) rejection of a submission by the server, e.g. the
 * asset's active period has closed. Distinct from AuthExpiredError: the user's
 * session is fine, so we must NOT trigger re-auth — we mark the submission
 * failed and stop retrying it.
 */
export class SubmissionRejectedError extends Error {
  readonly code: string
  readonly status: number

  constructor(code: string, message: string, status = 403) {
    super(message)
    this.name = 'SubmissionRejectedError'
    this.code = code
    this.status = status
  }
}

export function isSubmissionRejectedError(
  error: unknown,
): error is SubmissionRejectedError {
  return (
    error instanceof SubmissionRejectedError ||
    (error instanceof Error && error.name === 'SubmissionRejectedError')
  )
}
